var _style, _path, _path2, _path3, _circle, _circle2, _circle3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWaiverWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "waiver-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M927.9 590.6c-21.2-21.2-49.5-32.9-79.6-32.9-30.1 0-58.4 11.7-79.6 32.9l-222.5 222c-3.7 3.7-6.4 8.2-7.9 13.2l-48.5 159.5c-3.3 11-.4 23 7.6 31.2 5.9 6 14.1 9.5 22.6 9.5 2.8 0 5.7-.4 8.4-1.1L692 979.5c5.2-1.4 10-4.2 13.9-8.1L928 749.8c43.8-43.9 43.8-115.3-.1-159.2zM818.1 770.3l-149.3 149-1.7 1.7-2.3.6-82.3 22.8-15.8 4.4 4.8-15.7 24.1-79.3.7-2.2 1.6-1.6L748 700.3l6.4-6.3 6.4 6.4 57.3 57.3 6.4 6.4-6.4 6.2zm65.2-65.1l-7.9 7.8-6.4 6.4-6.4-6.4-57.3-57.3-6.4-6.4 6.4-6.4 7.8-7.8c9.3-9.3 21.8-14.5 35-14.5s25.7 5.1 35 14.5c19.5 19.4 19.5 50.8.2 70.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M372.3 1022.7H105.2c-17.9 0-32.5-14.6-32.5-32.5v-951c0-17.9 14.6-32.5 32.5-32.5h701.9c17.9 0 32.5 14.6 32.5 32.5v398.5c0 17.9-14.6 32.5-32.5 32.5s-32.5-14.6-32.5-32.5v-366H137.7v886h234.6c17.9 0 32.5 14.6 32.5 32.5s-14.6 32.5-32.5 32.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M672.9 317H335.7c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5h337.2c17.9 0 32.5 14.6 32.5 32.5S690.8 317 672.9 317z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 239.4,
    cy: 281.1,
    r: 32.6,
    fill: "#FFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.4,
    cy: 443.3,
    r: 32.6,
    fill: "#FFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.4,
    cy: 605.4,
    r: 32.6,
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M672.9 475.8H334.3c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5h338.6c17.9 0 32.5 14.6 32.5 32.5s-14.6 32.5-32.5 32.5zM527.3 637.9H335.7c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5h191.7c17.9 0 32.5 14.6 32.5 32.5s-14.6 32.5-32.6 32.5z"
  })));
}

export default SvgWaiverWhite;